<template lang="pug">
.options
  .backdrop
  .content
    .title VVR Fahrkarte
    .qr-area(v-if="qrcode")
      .qr-code(v-html="qrcode")
      .qr-motion-bar(role="presentation" aria-hidden="true")
        .qr-motion-indicator
    Loader(v-else)
    .current-time
      div {{ type }} - {{ validZones }}
      div {{ timeFrom }} - {{ timeUntil }}
      hr
      div {{ datetime[0] }}
      div {{ datetime[1] }}
    Button(color="gray" @click.native="close" center path="infoDialog.close.button").button
</template>

<script>
import { mapActions } from 'vuex';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import moment from 'moment';

export default {
  components: {
    Button,
    Loader,
  },
  props: ['overlaydata'],
  data() {
    return {
      datetime: [],
      qrcode: '',
      type: '',
      validZones: '',
      timeFrom: '',
      timeUntil: '',
    };
  },
  methods: {
    close() {
      this.$store.commit('openOverlay', '');
    },
    time() {
      this.datetime = [moment().format('DD.MM.YYYY'), moment().format('HH:mm:ss')];
    },
    ...mapActions(['publicTransportTicket']),
  },
  mounted() {
    this.time();
    this.interval = setInterval(this.time, 1000);
    this.publicTransportTicket()
      .then(data => {
        this.qrcode = data.qrcode;
        this.type = data.type;
        this.validZones = data.validZones;
        this.timeFrom = moment.unix(data.timeFrom).format('DD.MM.YYYY');
        this.timeUntil = moment.unix(data.timeUntil).format('DD.MM.YYYY');
      })
      .catch(error => {
        this.$store.commit('openOverlay', {
          overlayName: 'Info',
          overlayData: {
            title: 'Error',
            message: error.message,
          },
        });
      });
  },
};
</script>

<style lang="sass" scoped>
.options
  width: 100%
  height: 100vh
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  position: fixed
  max-width: 480px
  margin: 0 auto
  right: 0
  top: 0
  left: 0
  z-index: 3000
.backdrop
  background-color: rgba(0, 0, 0, .8)
  width: 100%
  height: 100vh
  position: absolute
  z-index: 6
.content
  z-index: 7
  background-color: #fff
  border-radius: 10px
  padding: 20px
  margin: 20px
  position: relative
  width: calc(100% - 40px)
  max-height: 100vh
  overflow: auto
.title
  font-size: 25px
  color: #1DB2D1
  text-align: center
.message
  text-align: center
  color: #454F63
  margin-top: 20px
  padding-left: 20px
  line-break: anywhere
.qr-area
  margin-top: 10px
  width: 100%
  max-width: 100vw
  max-height: 100vh
.qr-code
  width: 100%
  margin: 0
  padding: 0
  line-height: 0
  display: block
  ::v-deep .qrcode
    margin: 0 !important
    padding: 0 !important
    display: block
  ::v-deep img
    display: block
    max-width: 100%
  ::v-deep svg
    display: block
    width: 100%
    height: auto
    margin: 0
    padding: 0
.qr-motion-bar
  width: 100%
  height: 30px
  margin: 0
  padding: 0
  background: #00a9c8
  overflow: hidden
  position: relative
  border-radius: 0
.qr-motion-indicator
  position: absolute
  top: 0
  bottom: 0
  width: 45%
  left: -45%
  background: linear-gradient(90deg, rgba(0,0,0,0) 0%, #5fd9ea 40%, #5fd9ea 60%, rgba(0,0,0,0) 100%)
  filter: blur(0.2px) drop-shadow(0 0 6px rgba(255,255,255,0.45))
  animation: qrMotionSweep 1s ease-in-out infinite
  will-change: transform
@keyframes qrMotionSweep
  0%
    transform: translateX(0)
  100%
    transform: translateX(385%)
.button
  margin-top: 20px
.current-time
  margin: 1rem 0 2rem
  text-align: center
  font-size: 1.5rem
</style>
